<template>
    <div>
      <form @submit.prevent="searchStrategies">
        <label for="strategy">Strategy:</label>
        <input type="text" id="strategy" v-model="strategy" />
        <button type="submit">Search</button>
      </form>
  
      <div v-if="loading">
        Loading...
      </div>
      <div v-else>
        <div v-for="fund in funds" :key="fund.fund" class="fund-container">
          <h2>{{ fund.fund }}</h2>
          <div v-html="fund.strategy_narrative" class="strategy-narrative"></div>
          <p>{{ fund.principal_investment_strategy }}</p>
          <ul>
            <li v-for="holding in fund.holdings" :key="holding.identifier__ticker">
              {{ holding.identifier__ticker }}: {{ holding.value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        strategy: '',
        funds: [],
        loading: false,
      };
    },
    methods: {
      async searchStrategies() {
        this.loading = true;
  
        try {
          const response = await fetch(this.$root.$data.AI_ENDPOINT_URL+'/ai/search_strategies', { 
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-CSRFToken': this.$root.$data.csrfToken,
            },
            body: JSON.stringify({ strategy: this.strategy }) 
          });
          
          if(response.ok) {
            const data = await response.json();
            this.funds = data.funds;
          } else {
            console.error(`HTTP error: ${response.status}`);
          }
        } catch (error) {
          console.error(error);
        } finally {
          this.loading = false;
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .fund-container {
    margin-bottom: 1em;
    border: 1px solid #e5e5e5;
    padding: 1em;
    border-radius: 5px;
  }
  
  .strategy-narrative {
    text-align: justify;
    margin: 1em 0;
  }
  
  .strategy-narrative span {
    color: #333;
    font-family: 'Arial', sans-serif;
    line-height: 1.5em;
  }
  
  ul {
    list-style-type: none;
    padding: 0;
  }
  </style>
  